export default __webpack_public_path__ + "static/media/detail_big_2_2.c8f7f613.png";